import { render, staticRenderFns } from "./ChartBuilder.vue?vue&type=template&id=12438c06&"
import script from "./ChartBuilder.vue?vue&type=script&lang=js&"
export * from "./ChartBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports